<template>
  <v-container fluid>
    <div>
      <v-expansion-panel>
        <v-expansion-panel-content>
          <template #actions>
            <div />
          </template>
          <template #header>
            <v-layout
              row
              wrap
              class="justify-center"
              style="align-items: center"
            >
              <v-flex xs8>
                <v-card
                  flat
                  class="campaign-name"
                >
                  {{ campaign.name }}
                </v-card>
              </v-flex>
              <v-spacer />
              <v-flex
                xs4
                text-xs-center
              >
                <v-layout
                  row
                  wrap
                  style="align-items: center"
                >
                  <v-layout
                    row
                    wrap
                    class="justify-center contacts-sent-txt"
                    style="align-items: center"
                  >
                    <v-icon
                      color="#6ADDC8"
                      style="margin-right: 5px"
                    >
                      $vuetify.icons.doneIcon
                    </v-icon>
                    {{ sent }}
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    class="justify-center contacts-sent-txt"
                    style="align-items: center"
                  >
                    <v-icon
                      color="#FFC56F"
                      style="margin-right: 5px"
                    >
                      $vuetify.icons.alertIcon
                    </v-icon>
                    {{ pending }}
                  </v-layout>
                </v-layout>
              </v-flex>

              <v-flex
                xs12
                class="pt-0"
              >
                <v-card flat>
                  <v-progress-linear
                    v-model="progresso"
                    background-color="#DDDDDD"
                    height="5"
                    color="#6ADDC8"
                  />
                </v-card>
              </v-flex>
            </v-layout>
          </template>
          <!-- ******** Fim Header Panel ******** -->

          <!-- ******** Enquanto a pagina nao carrega ******** -->
          <v-card flat>
            <v-card-text>
              <v-layout row>
                <v-flex xs12>
                  <v-card class="pa-2">
                    <div
                      v-if="loading"
                      class="text-xs-center"
                    >
                      <v-progress-circular
                        :size="50"
                        :width="7"
                        color="primary"
                        indeterminate
                      />
                    </div>

                    <!-- ******** Inicio Panel Content ******** -->

                    <v-list
                      v-if="!loading"
                      subheader
                    >
                      <v-layout row>
                        <v-flex xs12>
                          <v-text-field
                            v-model="search"
                            label="Buscar"
                            color="#099AB1"
                            class="mt-0 pt-0"
                            prepend-icon="$vuetify.icons.searchIcon"
                          />
                        </v-flex>
                      </v-layout>
                      <div
                        v-if="loading2"
                        class="text-xs-center"
                      >
                        <v-progress-circular
                          :size="50"
                          :width="7"
                          color="#099AB1"
                          indeterminate
                        />
                      </div>

                      <div
                        v-if="
                          !loading2 && filteredUsers.length == 0 && pending > 0
                        "
                        class="text-xs-center"
                      >
                        <v-btn
                          depressed
                          dark
                          round
                          color="#099AB1"
                          class="text-lowercase mt-3"
                          @click="
                            loading2 = true;
                            getMessages(campaign.id);
                          "
                        >
                          Buscar mais contatos
                          <v-icon
                            right
                            dark
                          >
                            mdi-refresh
                          </v-icon>
                        </v-btn>
                      </div>
                      <virtualList
                        :size="61"
                        :remain="6"
                      >
                        <v-slide-y-transition
                          group
                          mode="out-in"
                          name="name"
                          tag="v-list"
                          leave-absolute
                        >
                          <div
                            v-for="item in filteredUsers"
                            :key="item.id"
                          >
                            <v-layout
                              row
                              wrap
                              class="justify-center"
                              style="align-items: center"
                            >
                              <v-flex xs1>
                                <v-menu
                                  bottom
                                  right
                                >
                                  <template
                                    #activator="{ on }"
                                    class="py-0"
                                  >
                                    <v-btn
                                      icon
                                      class="ma-0"
                                      v-on="on"
                                    >
                                      <v-icon
                                        color="#8A8691"
                                      >
                                        more_vert
                                      </v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list v-if="item.personId">
                                    <v-list-tile
                                      class="px-3"
                                      :to="'/contato/' + item.personId"
                                    >
                                      Ver Contato
                                    </v-list-tile>
                                  </v-list>
                                </v-menu>
                              </v-flex>
                              <v-flex xs11>
                                <v-list-tile
                                  avatar
                                  ripple
                                  :class="`tile`"
                                >
                                  <v-list-tile-avatar class="mr-2 pl-2">
                                    <div
                                      v-lazy-container="{
                                        error:
                                          'https://de0pbhtp0pb9.cloudfront.net/circle.png',
                                        loading:
                                          'https://de0pbhtp0pb9.cloudfront.net/circle.png',
                                      }"
                                    >
                                      <img
                                        v-if="
                                          item.leadCustomer &&
                                            item.leadCustomer.whatsapp
                                        "
                                        class="avatarImg"
                                        :data-src="item.leadCustomer.whatsapp.picture"
                                      >

                                      <img
                                        v-if="
                                          !item.leadCustomer ||
                                            !item.leadCustomer.whatsapp
                                        "
                                        class="avatarImg"
                                        :data-src="'https://de0pbhtp0pb9.cloudfront.net/circle.png'"
                                      >
                                    </div>
                                  </v-list-tile-avatar>

                                  <v-list-tile-content>
                                    <v-list-tile-title class="contact-name">
                                      {{ item.nome }}
                                      {{
                                        item.messageVariables.lastName && item.messageVariables.lastName != 'undefined' ? item.messageVariables.lastName : ''
                                      }}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title
                                      class="contact-phone"
                                      v-text="item.messageVariables.dddandPhone"
                                    />
                                  </v-list-tile-content>

                                  <v-list-tile-action class="mr-2">
                                    <v-layout row>
                                      <v-flex>
                                        <v-btn
                                          flat
                                          style="min-width: 45px"
                                          @click="sendMessage(item)"
                                        >
                                          <v-icon color="#231F20">
                                            $vuetify.icons.sendIcon
                                          </v-icon>
                                        </v-btn>
                                      </v-flex>
                                    </v-layout>
                                  </v-list-tile-action>
                                </v-list-tile>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-slide-y-transition>
                      </virtualList>
                    </v-list>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <RateCampaign
        v-model="showRate"
        :campaign="campaign"
      />

      <v-dialog
        v-model="blockDialog"
        max-width="290"
      >
        <v-card class="dialogCard">
          <v-card-title class>
            Deseja bloquear esse cliente?
          </v-card-title>

          <v-card-actions>
            <v-spacer />

            <v-btn
              round
              small
              outline
              flat="flat"
              class="text-lowercase"
              @click="blockDialog = false"
            >
              cancelar
            </v-btn>

            <v-btn
              round
              small
              outline
              flat="flat"
              class="text-lowercase"
              @click="muteUser"
            >
              bloquear
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
  <!-- ******** Fim Panel Content ******** -->
</template>

<script>
/* eslint-disable max-len */

import Vue from 'vue';
import virtualList from 'vue-virtual-scroll-list';
import { mapState, mapActions } from 'vuex';
import { APIService } from '@/resources/campanha.js';
import { EventBus } from '@/event-bus.js';

const api = new APIService();

export default {
  methods: {
    getCustomerDetails(item) {
      this.details = item;
    },
    emitSnackBar() {
      const snackBar = {};
      snackBar.text = 'Cliente bloqueado com sucesso!';
      snackBar.value = true;
      EventBus.$emit('activeSnackBar', snackBar);
    },
    async muteUser() {
      this.counterMute += 1;

      this.$ga.event({
        eventCategory: 'Campanha',
        eventAction: 'Bloquear',
        eventValue: this.counterMute,
      });
      const res = await api.updateStatus(this.selectedUser.idCliente, true);
      if (res.status == '200') {
        this.skipMessage(this.selectedUser);
        this.emitSnackBar();
        this.blockDialog = false;
      }
    },
    /* ******** Busca status da campanha (total, enviados, pendentes) ******** */
    getCampaignStats(retrieveMessages) {
      api
        .getCampaignStatsForSeller(this.campaign.id, this.$auth.user.sub)
        .then((data) => {
          this.sent = data.sent;
          this.pending = data.pending;
          this.total = data.total;
          this.loading = false;
          this.progresso = (this.sent * 100) / this.total;
          if (retrieveMessages) {
            this.getMessages(this.campaign.id);
          }
          this.getCampaign(this.campaign.id);
        });
    },

    /* ******** Envia a mensagem baseada na campanha ******** */
    sendMessage(item) {
      const USE_APP = JSON.parse(localStorage.getItem('USE_APP')) || false;
      item.sent = true;
      this.counterSend += 1;

      this.$ga.event({
        eventCategory: 'Campanha',
        eventAction: 'enviar',
        eventValue: this.counterSend,
      });

      api
        .sendMessage(this.campaign.id, item.id, USE_APP)
        .then((response) => {
          this.getCampaignStats(
            this.items.filter(
              (item) => !item.sent && !item.skipped,
            ).length <= 10,
          );

          const url = response.url + window.encodeURIComponent(response.message);

          if (USE_APP) {
            window.open('whatsapp://');

            setTimeout(() => {
              window.open(url);
              window.open(url);
            }, 5000);

          } else {
            window.open(url);
          }

        }).catch((err) => {
          const snackBar = {};
          snackBar.text = err.response.data.message;
          snackBar.value = true;
          snackBar.multiline = true;
          snackBar.color = '#140C22';
          snackBar.timeout = 6000;
          EventBus.$emit('activeSnackBar', snackBar);
        });
    },
    skipMessage(item) {
      item.skipped = true;
      this.counterSkip += 1;

      this.$ga.event({
        eventCategory: 'Campanha',
        eventAction: 'Pular',
        eventValue: this.counterSkip,
      });
      api.skipMessage(this.campaign.id, item.id).then((response) => {
        this.getCampaignStats(
          this.items.filter(
            (item) => item.sent !== true && item.skipped !== true,
          ).length <= 10,
        );
      });
    },
    /* ******** Armazena conteudo da mensagem ******** */
    getMessages(idcamp) {
      this.items = [];

      api
        .getCampaignMessagesForSeller(idcamp, this.$auth.user.sub)
        .node('{nome}', (e) => {
          this.items.push(e);
        })
        .done((things) => {
          this.loading = false;
          this.loading2 = false;
        })
        .fail((e) => {
          this.loading = false;
          this.loading2 = false;
          console.error(e);
          this.getMessages(idcamp, false);
        });
    },
    /* ******** Busca campanha por id e armazena usuarios pendentes ******** */
    getCampaign(idcamp) {
      api.getCampaign(idcamp).then((data) => {});
    },
  },
  computed: {
    ...mapState(['agenda']),
    filteredUsers() {
      return this.items
        .map((item) => {
          if (!item.nome) item.nome = 'Não identificado';
          return item;
        })
        .filter(
          (item) => item.sent !== true
            && item.skipped !== true
            && item.nome
            && item.nome.toLowerCase().match(this.search.toLowerCase()),
        );
    },
    /* ******** Verifica se o contato e duplicado ******** */
    isSameFirstLetter(item) {
      if (!item.nome) {
        return false;
      }

      const letter = item.nome.indexOf(0);
      const same = letter === lastLetter;

      if (!same) {
        lastLetter = letter;
      }
      return same;
    },
  },
  /* ******** Inicia funcao quando montado ******** */
  mounted() {
    this.getCampaignStats(true);
  },
  props: {
    campaign: Object,
    id: String,
  },
  data: () => ({
    showDetails: false,
    details: null,
    showRate: false,
    counterMute: 0,
    counterSend: 0,
    counterSkip: 0,
    selectedUser: null,
    blockDialog: false,
    loading: true,
    loading2: true,
    sent: 0,
    total: 1,
    pending: 0,
    progresso: 0,
    items: [],
    search: '',
    handler: new Vue(),
    listItem: '',
  }),
};
</script>

<style>

.v-list__tile__title {
  font-size: 12px;
}
.v-list__tile__sub-title {
  font-size: 12px;
}
.trunk {
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.pendente {
  font-size: 1.1em;
}
.v-expansion-panel__header {
  padding-top: 12px;
  padding-right: 12px;
  padding-left: 12px;
  padding-bottom: 0px;
  border-radius: 10px;
  border-top: 1px solid #e0e0e0;
}

.v-expansion-panel {
  box-shadow: none;
  border-radius: 10px;
}

.v-expansion-panel__container {
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}

.v-expansion-panel__body > .v-card {
  border-right: 0.5px solid #e0e0e0;
  border-radius: 0px 0px 10px 10px;
}

.v-expansion-panel__container--active {
  border: 1px solid #e0e0e0;
}

.container.grid-list-lg .layout .flex {
  padding-top: 2px;
}
.opcSlide {
  opacity: 0.4;
}
</style>

<style scoped>
.dialogCard {
  box-shadow: none;
  border-radius: 10px;
}
.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.tile {
  margin: 2px;
  overflow-y: hidden;
  overflow-x: hidden;
  border-bottom: 0.829458px solid #8A8691;
}
.campaign-name {
  font-family: 'Nunito sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}

.v-card__text {
  padding-top: 0px;
  padding-left: 10px;
  padding-right: 5px;
  padding-bottom: 2px;
}

.v-subheader {
  padding-left: 0px;
}
.v-card {
  box-shadow: 0px 0px 0px 0px;
}
.contact-name {
  font-family: 'Nunito sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
}
.contact-phone {
  font-family: 'Nunito sans';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #B0B0B0;
}
.contacts-sent-txt {
  font-family: 'Nunito';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
}
</style>